<!-- Step 2: Define a triggering event -->
<div *ngIf="currentStepKey === 'trigger'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Define a triggering event</div>

  <div class="radio-list">
    <label class="radio-option" *ngFor="let opt of triggerOptions"
           [class.disabled]="!opt.enabled"
           [class.selected]="selectedTrigger === opt.key"
           [title]="opt.enabled ? '' : 'Coming soon'"
           (click)="selectTrigger(opt.key)">
      <input type="radio" name="notifTrigger" [checked]="selectedTrigger === opt.key" [disabled]="!opt.enabled" />
      <span>{{ opt.label }}</span>
    </label>
  </div>
</div>

<!-- Timer step: configure the single/repeat timer in the right-pane editor -->
<div *ngIf="currentStepKey === 'timer'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Select single or repeat timer</div>
  <div class="hint">
    Configure the single or repeat timer in the editor on the right, then continue.
  </div>
</div>

<!-- Motion step: pick the Scoutview gateway camera (further options in the right pane) -->
<div *ngIf="currentStepKey === 'motion'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Select Scoutview Gateway Camera</div>
  <div class="hint">Configure the motion options (sensitivity, detection area, sleep) in the editor on the right.</div>
  <div class="form-group" style="margin-top: 12px;">
    <label>Gateway</label>
    <ng-select [items]="gatewayNames"
               placeholder="Search and Select Gateway"
               [(ngModel)]="motionCondition.deviceName"
               (ngModelChange)="onMotionGatewayChanged()">
    </ng-select>
  </div>
</div>

<!-- Step 3: Select sensors or sensor groups to watch -->
<div *ngIf="currentStepKey === 'sensors'" class="wizard-step wizard-step-fill">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Select Sensors or Sensor Groups to watch</div>

  <div class="preset-list">
    <label class="preset-check">
      <input type="checkbox" [(ngModel)]="n.sensorPreset.recentlyAddedOrModified" (ngModelChange)="onPresetChanged()" />
      Search recently added or modified
    </label>
    <label class="preset-check">
      <input type="checkbox" [(ngModel)]="n.sensorPreset.assignedToMeOrGroup" (ngModelChange)="onPresetChanged()" />
      Search sensors and sensor groups assigned to me or my user groups
    </label>
    <label class="preset-check">
      <input type="checkbox" [(ngModel)]="n.sensorPreset.allSensorsAndGroups" (ngModelChange)="onPresetChanged()" />
      Search all sensors and sensor groups
    </label>
  </div>

  <div class="grow-panel list-panel">
    <div class="list-panel-header">
      <label>Sensors and Groups</label>
      <label class="list-panel-count">Selected Sensors: {{ n.selectedSensors.length }}</label>
    </div>
    <div class="list-panel-body">
      <div class="list-search-row">
        <div class="select-all-toggle" (click)="toggleCheckedSensors()" title="Select / clear all">▣</div>
        <i class="fa fa-search list-search-icon" (click)="sensorSearchTextChanged()"></i>
        <form (ngSubmit)="sensorSearchTextChanged()">
          <input [(ngModel)]="searchSensorsText" placeholder="Search" type="text" name="searchSensorsText" autocomplete="off" class="list-search-input" />
        </form>
      </div>

      <p-table [columns]="SensorsAndGroupsCols" [value]="sensorsAndGroupsDisplayed" [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="i">
          <tr class="list-row">
            <td [ngStyle]="{'width': columns[0].width}" class="list-cell">
              <input *ngIf="rowData.isSensorGroup" type="checkbox" name="grp{{i}}" [(ngModel)]="rowData.checked" [ngModelOptions]="{standalone: true}"
                     [indeterminate]="rowData.indeterminate" (ngModelChange)="onGroupChecked(rowData)" style="cursor: pointer;" />
              <p-checkbox *ngIf="rowData.isSensor" id="{{i}}" name="{{i}}" [(ngModel)]="rowData.checked" binary="true" (ngModelChange)="sensorSelectionChanged()"></p-checkbox>
            </td>
            <td [ngStyle]="{'width': columns[1].width}" class="list-cell">
              <div *ngIf="rowData.isSensorGroup" class="group-label" (click)="toggleGroupExpanded(rowData)">
                <i class="fa" [ngClass]="rowData.expanded ? 'fa-chevron-down' : 'fa-chevron-right'" style="margin-right: 6px;"></i>
                <i class="fa fa-folder" style="margin-right: 5px;"></i>
                {{ rowData.name }} ({{ groupCheckedCount(rowData) }}/{{ rowData.count }})
              </div>
              <div *ngIf="rowData.isSensor" class="sensor-label">{{ rowData.name }}</div>
            </td>
          </tr>
          <ng-container *ngIf="rowData.isSensorGroup && rowData.expanded">
            <tr *ngFor="let child of rowData.children" class="list-row">
              <td [ngStyle]="{'width': columns[0].width}" class="list-cell">
                <p-checkbox name="grp{{i}}child{{child.id}}" [(ngModel)]="child.checked" [ngModelOptions]="{standalone: true}" binary="true" (ngModelChange)="onGroupChildChecked(rowData)"></p-checkbox>
              </td>
              <td [ngStyle]="{'width': columns[1].width}" class="list-cell child-cell">{{ child.name }}</td>
            </tr>
          </ng-container>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Step 4: Select a reading type to watch -->
<div *ngIf="currentStepKey === 'readingType'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Select a reading type to watch</div>

  <div class="form-group">
    <ng-select [items]="n.availableReadingTypes"
               bindLabel="type"
               placeholder="Search or Select"
               [(ngModel)]="condition.sensorReadingType"
               (ngModelChange)="onReadingTypeChanged()">
    </ng-select>
    <div class="hint" *ngIf="n.selectedSensors.length === 0">Select sensors in the previous step first.</div>
  </div>
</div>

<!-- Step 5: What to watch for in the readings -->
<div *ngIf="currentStepKey === 'condition'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">What to watch for in the readings</div>

  <div class="radio-list">
    <label class="radio-option condition-row" *ngFor="let opt of conditionOptions"
           [class.selected]="n.conditionPreset === opt.key"
           (click)="applyConditionPreset(opt.key)">
      <input type="radio" name="notifCondition" [checked]="n.conditionPreset === opt.key" />
      <span class="condition-label">{{ opt.label }}</span>
      <input type="number" class="form-control threshold-input"
             [(ngModel)]="condition.threshold" [disabled]="n.conditionPreset !== opt.key"
             (ngModelChange)="onThresholdChanged()" (click)="$event.stopPropagation()" />
    </label>
  </div>
</div>

<!-- Step 6: Define action or notification -->
<div *ngIf="currentStepKey === 'action'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>
  <div class="step-subtitle">Define action or notification</div>

  <div class="radio-list">
    <label class="radio-option" *ngFor="let opt of actionOptions"
           [class.selected]="selectedAction === opt.key"
           (click)="selectAction(opt.key)">
      <input type="radio" name="notifAction" [checked]="selectedAction === opt.key" />
      <span>{{ opt.label }}</span>
    </label>
  </div>

  <div class="form-group" *ngIf="selectedAction === 'email'">
    <label>Email address</label>
    <input type="text" name="notifEmail" class="form-control" placeholder="you@example.com"
           [(ngModel)]="action.destination" (ngModelChange)="onActionDetailChanged()" />
  </div>
  <div class="hint" *ngIf="selectedAction !== 'email'">
    Configure the action details in the editor on the right, then click Finish.
  </div>
</div>

<!-- Step 7: Save -->
<div *ngIf="currentStepKey === 'save'" class="wizard-step">
  <div class="step-title">Create a Notification &amp; Action</div>

  <div class="step-subtitle">Save Notification</div>
  <div class="form-group">
    <label>Notification Name</label>
    <input type="text" name="notifName" class="form-control" placeholder="Notification name"
           [(ngModel)]="event.name" (ngModelChange)="onSaveFieldChanged()" />
  </div>
  <div class="form-group">
    <label>Access Group</label>
    <ngx-select-dropdown [(ngModel)]="n.accessUserGroup" [config]="userGroupConfig"
                         [options]="associatedUserGroups" name="notifAccessGroup"
                         (change)="onAccessGroupChanged()"></ngx-select-dropdown>
  </div>

  <div class="step-subtitle" style="margin-top: 18px;">Create or update dashboard</div>
  <div class="form-group radio-row">
    <label>
      <input type="radio" name="notifDashTarget" value="new"
             [(ngModel)]="n.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to new dashboard
    </label>
    <label>
      <input type="radio" name="notifDashTarget" value="existing"
             [(ngModel)]="n.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to existing dashboard
    </label>
  </div>

  <div class="form-group" *ngIf="n.dashboardTargetMode === 'new'">
    <input type="text" name="notifNewDashName" class="form-control" placeholder="New dashboard name"
           [class.input-error]="newDashboardNameTaken"
           [(ngModel)]="n.newDashboardName" (ngModelChange)="onSaveFieldChanged()" />
    <div class="error-hint" *ngIf="newDashboardNameTaken">A dashboard with this name already exists.</div>
  </div>
  <div class="form-group" *ngIf="n.dashboardTargetMode === 'existing'">
    <ng-select [items]="dashboards"
               bindLabel="name"
               placeholder="Select Dashboard"
               [(ngModel)]="n.targetDashboard"
               (ngModelChange)="onSaveFieldChanged()">
    </ng-select>
  </div>
</div>
